export default __webpack_public_path__ + "static/help_06_03-2-3e4d00d5e0658271f0acbb69c5db8798.png";